import { MethodicsService } from "@/common/api.service";
import { FETCH_METHODICS } from "./actions.type";

const state = {
  methodics: {
    counts: 0,
    items: []
  }
};

const getters = {
  methodics() {
    return state.methodics;
  }
};

const actions = {
  [FETCH_METHODICS]({ state }, lisizng) {
    MethodicsService.list(lisizng)
      .then(({ data }) => {
        state.methodics = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

export default {
  state,
  getters,
  actions
};
